import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { GenericComponentsModule } from '@helios/generic-components'
import {
  NgbAccordionModule,
  NgbDropdownModule,
  NgbModalModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap'
import { NgSelectModule } from '@ng-select/ng-select'
import { TableLayoutModule } from '@northfork/ag-grid-angular'
import {
  InlineEditModule,
  NfFormsModule,
  ToastModule,
  ToggleModule,
} from '@northfork/ng-basics'
import { BulkCashEntryComponent } from './components/bulk-transaction/bulk-cash-entry/bulk-cash-entry.component'
import { BulkDirectTransferModalComponent } from './components/bulk-transaction/bulk-direct-transfer/bulk-direct-transfer.component'
import { BulkFxForwardComponent } from './components/bulk-transaction/bulk-fx-forward/bulk-fx-forward.component'
import { BulkFxSpotTradeComponent } from './components/bulk-transaction/bulk-fx-spot-trade/bulk-fx-spot-trade.component'
import { BulkLoadComponent } from './components/bulk-transaction/bulk-load/bulk-load.component'
import { BulkSecurityExchangeComponent } from './components/bulk-transaction/bulk-security-exchange/bulk-security-exchange.component'
import { BulkSecurityTransferInComponent } from './components/bulk-transaction/bulk-security-transfer-in/bulk-security-transfer-in.component'
import { BulkSecurityTransferOutComponent } from './components/bulk-transaction/bulk-security-transfer-out/bulk-security-transfer-out.component'
import { BulkTradeEntryModalComponent } from './components/bulk-transaction/bulk-trade-entry/bulk-trade-entry.component'
import { BulkTransactionsSaveConfirmationModalComponent } from './components/bulk-transaction/bulk-transactions-confirm-button-modal/bulk-transactions-confirm-button-modal.component'
import { BulkWireTransferComponent } from './components/bulk-transaction/bulk-wire-transfer/bulk-wire-transfer.component'
import { DeleteBulkTransactionsModalComponent } from './components/bulk-transaction/delete-bulk-transaction/delete-bulk-transactions-component'
import { BvMvBasisComponent } from './components/bv-mv-basis-selector/bv-mv-basis-selector.component'
import { CashEntryMatchesComponent } from './components/single-transaction/cash-entry/cash-entry-matches/cash-entry-matches.component'
import { CashEntryComponent } from './components/single-transaction/cash-entry/cash-entry.component'
import { DirectTransferModule } from './components/single-transaction/direct-transfer/direct-transfer.module'
import { FxForwardModalComponent } from './components/single-transaction/fx-forward/fx-forward.component'
import { FxSpotTradeModalComponent } from './components/single-transaction/fx-spot-trade/fx-spot-trade.component'
import { RequestPriceComponent } from './components/single-transaction/security-transfer/request-price/request-price.component'
import { SecurityTransferBasisGridComponent } from './components/single-transaction/security-transfer/security-transfer-basis/security-transfer-basis-grid.component'
import { SecurityTransferGenericGridComponent } from './components/single-transaction/security-transfer/security-transfer-generic/security-transfer-generic-grid.component'
import { SecurityTransferSaveConfirmationModalComponent } from './components/single-transaction/security-transfer/security-transfer-modal/security-transfer-confirm-button-modal'
import { SecurityTransferModalComponent } from './components/single-transaction/security-transfer/security-transfer.component'
import { CalculatePriceComponent } from './components/single-transaction/trade-entry/calculate-price/calculate-price.component'
import { TradeEntryModalComponent } from './components/single-transaction/trade-entry/trade-entry.component'
import { TradeMatchesComponent } from './components/single-transaction/trade-entry/trade-matches/trade-matches.component'
import { WireTransferComponent } from './components/single-transaction/wire-transfer/wire-transfer.component'

@NgModule({
  imports: [
    // Angular Dependencies
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbTooltipModule,

    // Third Party Dependencies
    NgbDropdownModule,
    NgSelectModule,

    // Northfork Dependencies
    InlineEditModule,
    NfFormsModule,
    NgbModalModule,
    TableLayoutModule,
    ToastModule,
    ToggleModule,
    NgbAccordionModule,

    // Helios Dependencies
    GenericComponentsModule,

    // Widget Modules
    DirectTransferModule,
  ],
  declarations: [
    FxSpotTradeModalComponent,
    CashEntryComponent,
    TradeEntryModalComponent,
    FxForwardModalComponent,
    SecurityTransferModalComponent,
    SecurityTransferGenericGridComponent,
    SecurityTransferBasisGridComponent,
    WireTransferComponent,
    CalculatePriceComponent,
    RequestPriceComponent,
    SecurityTransferSaveConfirmationModalComponent,
    BulkCashEntryComponent,
    BulkTradeEntryModalComponent,
    BulkDirectTransferModalComponent,
    BulkTransactionsSaveConfirmationModalComponent,
    BulkLoadComponent,
    BvMvBasisComponent,
    BulkFxForwardComponent,
    BulkFxSpotTradeComponent,
    BulkWireTransferComponent,
    DeleteBulkTransactionsModalComponent,
    CashEntryMatchesComponent,
    TradeMatchesComponent,
    BulkSecurityTransferInComponent,
    BulkSecurityTransferOutComponent,
    BulkSecurityExchangeComponent,
  ],
  exports: [
    DirectTransferModule,
    FxSpotTradeModalComponent,
    CashEntryComponent,
    TradeEntryModalComponent,
    FxForwardModalComponent,
    SecurityTransferModalComponent,
    WireTransferComponent,
    SecurityTransferGenericGridComponent,
    SecurityTransferBasisGridComponent,
    SecurityTransferSaveConfirmationModalComponent,
    BulkCashEntryComponent,
    BulkTradeEntryModalComponent,
    BulkDirectTransferModalComponent,
    BulkTransactionsSaveConfirmationModalComponent,
    CashEntryMatchesComponent,
    TradeMatchesComponent,
    BulkSecurityTransferInComponent,
    BulkSecurityTransferOutComponent,
  ],
})
export class CreateTransactionsModalModule {}
